const ITEMS = [
  {
    title: '韩漫精选：从恋爱到悬疑，这些神作你不能错过',
    tag: '编辑精选',
    desc: '精心挑选当前最热门的韩漫作品合集，从甜蜜恋爱到烧脑悬疑，每部都值得熬夜追完。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20themed%20banner%20illustration%20with%20soft%20gradient%20background%20in%20warm%20peach%20and%20cream%20tones%2C%20decorative%20comic%20panel%20elements%2C%20clean%20minimal%20aesthetic%2C%20subtle%20texture%2C%20artistic%20layout%2C%20harmonious%20warm%20color%20palette%2C%20reading%20platform%20feature%20card%20design&width=800&height=500&seq=carousel-manga-01&orientation=landscape',
  },
  {
    title: '国漫崛起：古风玄幻巅峰对决，画风炸裂',
    tag: '编辑精选',
    desc: '国产漫画近年佳作频出，古风玄幻题材尤其亮眼，精美画风与深刻剧情相得益彰。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20with%20ancient%20Chinese%20fantasy%20motifs%2C%20flowing%20clouds%20and%20mountains%2C%20warm%20golden%20and%20cream%20gradient%20background%2C%20delicate%20ink%20wash%20style%2C%20soft%20ambient%20lighting%2C%20clean%20artistic%20composition%2C%20harmonious%20color%20palette&width=800&height=500&seq=carousel-manga-02&orientation=landscape',
  },
  {
    title: '日漫经典：从异世界到日常，治愈你的每一天',
    tag: '编辑精选',
    desc: '日漫的魅力在于对日常生活的细腻描绘和天马行空的想象力，这里有最值得追的日漫佳作。',
    image: 'https://readdy.ai/api/search-image?query=A%20gentle%20illustration%20of%20a%20peaceful%20Japanese%20countryside%20scene%20with%20cherry%20blossoms%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20sunlight%20filtering%20through%20trees%2C%20delicate%20anime%20art%20style%2C%20clean%20composition%2C%20serene%20and%20healing%20atmosphere&width=800&height=500&seq=carousel-manga-03&orientation=landscape',
  },
  {
    title: '下拉式追更推荐：一口气读完的爽快体验',
    tag: '编辑精选',
    desc: '适合下拉式追更的长篇连载漫画推荐，剧情紧凑节奏明快，让你根本停不下来。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20with%20scrolling%20comic%20panels%20flowing%20vertically%2C%20warm%20cream%20and%20peach%20gradient%20background%2C%20action%20lines%20and%20motion%20effects%2C%20stylized%20anime%20aesthetic%2C%20clean%20modern%20design%2C%20harmonious%20composition%2C%20energetic%20yet%20elegant&width=800&height=500&seq=carousel-manga-04&orientation=landscape',
  },
  {
    title: '新番速递：本月最值得期待的新连载作品',
    tag: '编辑精选',
    desc: '每月新上线的漫画作品抢先看，第一时间锁定你感兴趣的新连载，占领先机开始追更。',
    image: 'https://readdy.ai/api/search-image?query=A%20fresh%20and%20vibrant%20illustration%20with%20new%20beginnings%20theme%2C%20sparkling%20light%20effects%2C%20warm%20peach%20and%20cream%20gradient%20background%2C%20soft%20dreamy%20atmosphere%2C%20stylized%20anime%20art%2C%20clean%20minimal%20composition%2C%20harmonious%20color%20palette%2C%20announcement%20banner%20style&width=800&height=500&seq=carousel-manga-05&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            编辑精选
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队精心策划的专题推荐，为你发掘更多值得追的好漫画
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 md:gap-6">
          {ITEMS.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col sm:flex-row lg:flex-col flex-1 bg-background-100 rounded-2xl border border-background-200/50 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer min-w-0"
            >
              <div className="relative sm:w-48 lg:w-full aspect-[16/10] lg:aspect-[16/9] overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.image}
                  alt={`香香漫画 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="text-xs text-accent-600 font-semibold">{item.tag}</span>
                <h3 className="mt-2 text-sm md:text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}